// Global function to send diagnostic data to the app
window.sendDiagData = async function (action, data) {
  if (!action || !data) {
    throw new Error('Missing action or data parameters in sendDiagData function');
  }
  let method = action == "delete" ? "DELETE" : "POST";
  let response = await fetch(`/apps/dlab-diag/${action}`, {
    method: method,
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });
  return response;
};
document.addEventListener('DOMContentLoaded', () => {
  // Open cart if the hash is #cart
  if (window.location.hash == "#cart" && document.querySelector("#mini-cart") !== null) {
    document.querySelector("#mini-cart").open = true;
    window.location.hash = '';
  }

  // Display account notification if diagnostic result is not saved
  const diagResult = JSON.parse(localStorage.getItem('diagnostic-result'));
  if (diagResult && !window.customerId) {
    const diagDate = new Date(diagResult.diagnosticDate);
    const nowDate = new Date();
    const hoursDifference = (nowDate - diagDate) / 36e5; // Difference in hours

    if (hoursDifference <= 24) {
      document.querySelector('.header__icon-wrapper--account').classList.add('diag-not-saved');
    }
  }
});

// MENU NAV
let menuButtons = document.querySelectorAll('.header__icon-wrapper');
menuButtons.forEach(menuButton => {
  menuButton.addEventListener('click', () => {
    let icon = menuButton.querySelector('.icon--menu');
    if (icon) {
      if (icon.classList.contains('open')) {
        icon.classList.remove('open');
      } else {
        icon.classList.add('open');
      }
    }
  });
});

// Open backup popup when account icon has "diag-not-saved" class
let accountIcon = document.querySelector('.header__icon-wrapper--account');
let backupPopup = document.querySelector('.login-popup');
accountIcon.addEventListener('click', e => {
  if (accountIcon && accountIcon.classList.contains('diag-not-saved') && backupPopup) {
    e.preventDefault();
    backupPopup.classList.add('is-opened');
  }
});
if (backupPopup) {
  let backupPopupClose = backupPopup.querySelector('.login-popup__close');
  let backupPopupOverlay = backupPopup.querySelector('.login-popup__overlay');
  backupPopupClose.addEventListener('click', () => {
    backupPopup.classList.remove('is-opened');
    document.querySelector('html').classList.remove('lock-all');
  });
  backupPopupOverlay.addEventListener('click', () => {
    backupPopup.classList.remove('is-opened');
    document.querySelector('html').classList.remove('lock-all');
  });
}
window.reloadTrustpilotWidget = function () {
  if (window.Trustpilot) {
    const trustboxes = document.getElementsByClassName("trustpilot-widget");
    for (let i = 0; i < trustboxes.length; i++) {
      window.Trustpilot.loadFromElement(trustboxes[i]);
    }
  } else {
    // Si le script Trustpilot n'est pas encore chargé, on le charge
    const trustpilotScript = document.createElement("script");
    trustpilotScript.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    trustpilotScript.async = true;
    document.head.appendChild(trustpilotScript);
    trustpilotScript.addEventListener('load', () => {
      const trustboxes = document.getElementsByClassName("trustpilot-widget");
      for (let i = 0; i < trustboxes.length; i++) {
        window.Trustpilot.loadFromElement(trustboxes[i]);
      }
    });
  }
};